import { render, staticRenderFns } from "./FullFrequencyResult.vue?vue&type=template&id=09715772&"
import script from "./FullFrequencyResult.vue?vue&type=script&lang=js&"
export * from "./FullFrequencyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports